import { render } from "./AllElements.vue?vue&type=template&id=194ac333"
import script from "./AllElements.vue?vue&type=script&lang=js"
export * from "./AllElements.vue?vue&type=script&lang=js"

import "./AllElements.vue?vue&type=style&index=0&id=194ac333&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__